import React from "react";
import {
  Box,
  Collapse,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

export default function SidebarMenuSection({
  title,
  icon,
  sectionKey,
  openSection,
  toggleSection,
  items,
  navigate,
  isActive,
}) {
  return (
    <>
      <ListItemButton
        onClick={() => toggleSection(sectionKey)}
        sx={{
          minHeight: 44,
          borderRadius: "12px",
          px: 1,
          color: "#cbd5e1",
          mb: 0.6,
          "&:hover": {
            bgcolor: "rgba(148,163,184,0.08)",
          },
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 34,
            color: "#cbd5e1",
          }}
        >
          {icon}
        </ListItemIcon>

        <ListItemText
          primary={title}
          primaryTypographyProps={{
            fontWeight: 600,
            fontSize: 13.6,
          }}
        />

        {openSection === sectionKey ? (
          <ExpandLessRoundedIcon
            sx={{ color: "rgba(226,232,240,0.62)", fontSize: 20 }}
          />
        ) : (
          <ExpandMoreRoundedIcon
            sx={{ color: "rgba(226,232,240,0.62)", fontSize: 20 }}
          />
        )}
      </ListItemButton>

      <Collapse in={openSection === sectionKey}>
        <Box
          sx={{
            pl: 0.8,
            pr: 0.1,
            display: "grid",
            gap: 0.45,
            mb: 0.6,
          }}
        >
          {items.map((item) => {
            const active = isActive(item.path);

            return (
              <ListItemButton
                key={item.path}
                onClick={() => navigate(item.path)}
                sx={{
                  minHeight: 42,
                  borderRadius: "12px",
                  px: 1,
                  color: active
                    ? "#e2e8f0"
                    : "rgba(226,232,240,0.72)",
                  bgcolor: active
                    ? "rgba(148,163,184,0.14)"
                    : "transparent",
                  border: active
                    ? "1px solid rgba(148,163,184,0.18)"
                    : "1px solid transparent",
                  "&:hover": {
                    bgcolor: active
                      ? "rgba(148,163,184,0.14)"
                      : "rgba(148,163,184,0.08)",
                  },
                }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontWeight: active ? 700 : 600,
                    fontSize: 13.4,
                  }}
                />
              </ListItemButton>
            );
          })}
        </Box>
      </Collapse>
    </>
  );
}